import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForLivePartnersComponent extends Component {
  // Defaults
  availableFilters = [
    ...this.defaultFilters,
    {
      key: 'partnerType',
      type: 'selectRelationship',
      recordType: 'category',
      useLocaleFilter: true,
      queryParams: {
        'filter[type]': 'P_TYPE_LIVE',
        'sort[name]': 'ASC',
      },
    },
    {
      key: 'customFilter',
      type: 'selectCustom',
      options: [
        { property: 'dgg', value: 1 },
        { property: 'notDgg', value: 0 },
      ],
    },
  ];

  defaultColumns = [
    'id',
    'name',
    'city',
    'country',
    'partnerType',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'zipcode',
      sortable: true,
    },
    {
      property: 'city',
      sortable: true,
    },
    {
      property: 'country',
      type: 'relation',
    },
    {
      property: 'street',
      sortable: true,
    },
    {
      property: 'partnerType',
      type: 'relation',
    },
    {
      property: 'link',
      type: 'relation',
    },
    {
      property: 'dgg',
      sortable: true,
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
